// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2ZyRk","content":"styles_content__3kbjJ","checkbox":"styles_checkbox__3B3_k","checkboxLabel":"styles_checkboxLabel__ZlztL"};